import './App.css';

import NB from './components/navbar';
import Game from './components/Game';

function App() {
  return (
    <div className="App">
      <NB></NB>
      <Game></Game>

    </div>

  );
}

export default App;
